module.exports = __webpack_public_path__ + "img/0.134661d4.png";